import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./ControlledAccordions.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function ControlledAccordions() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="accordian">
      <h2>General Information and Conditions</h2>
      <div className="accordian_max-width">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>
              <b
                style={{
                  fontFamily: "Noto Sans Lao",
                  fontSize: "20px",
                }}
              >
                ຂໍ້ມູນທົ່ວໄປ
              </b>
            </Typography>
            <Typography className={classes.secondaryHeading}>
              <b>Overall course highlight and proposal</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{
              display: "block",
              textAlign: "justify",
              fontFamily: "Phetsarath OT",
              fontSize: "17px",
            }}
          >
            <b>ເປີດອີກແລ້ວ ກັບຫຼັກສູດ FULL STACK Web Application Programmer.</b>
            <p>
              ຫຼັກສູດເດີມ ເພີ່ມເຕີມຄືພັດທະນາເນື້ອຫາໃໝ່ທີ່ຄວບຄຸມຫຼາຍກວ່າເດີມ ແລະ
              ເປັນມືອາຊີບຫຼາຍຂຶ້ນ. ທີ່ຈະປ່ຽນໃຫ້ທ່ານກາຍເປັນນັກພັດທະນາໂປຼແກຼມ
              (Full Stack Web Application Programmer)
              ແບບມືອາຊີບໄດ້ໃນໄລຍະເວລາອັນສັ້ນ ທີ່ຈະເຮັດໃຫ້ທ່ານເຂົ້າໃຈງ່າຍ (Unlock
              your programming knowledge) ແລະ ສາມາດພັດທະນາຕໍ່ໄດ້ດ້ວຍຕົວເອງ.
            </p>
            <p>
              ປັດຈະບັນ UX/UI ກຳລັງເປັນທີ່ນິຍົມໃນການພັດທະນາລະບົບຕ່າງໆ.
              ທ່ານຈະໄດ້ຮຽນຮູ້ທຸກຢ່າງກ່ຽວກັບເທັກໂນໂລຢີ່ຂອງໂປຼແກຼມທີ່ທັນສະໄໝ ແລະ
              ຖືກນຳໃຊ້ເປັນອັນດັບຕົ້ນໆຂອງໂລກ. ເຊິ່ງກວມເອົາການພັດທະນາຕັ້ງແຕ່
              Frontend, Backend ແລະ ລະບົບຖານຂໍ້ມູນ (Database).
            </p>
            <p>
              <b>Frontend:</b>&nbsp; ທ່ານຈະໄດ້ຮຽນຮູ້ການພັດທະນາລະບົບໂດຍການນຳໃຊ້
              ReactJS (React JavaScript) ເປັນຫຼັກ ລວມກັບ HTML, CSS ແລະ Material
              UI ໃນການອອກແບບລະບົບ Frontend ໃຫ້ໄດ້ຕາມຄວາມຕ້ອງການຂອງທ່ານເອງ.
            </p>
            <p>
              <b>Backend:</b>&nbsp;
              ທ່ານຈະໄດ້ຮຽນຮູ້ກ່ຽວກັບການພັດທະນາລະບົບໂດຍການນຳໃຊ້ Visual Studio
              2019 ເພື່ອສ້າງ Application Programming Interface (API)
              ໃຫ້ຢູ່ໃນຮູບແບບ JSON ຫຼື XML ພ້ອມກັບສ້າງ API ໃຫ້ມີຄວາມປອດໄພ
              ໂດຍມີການລະບຸຕົວຕົນຜ່ານ JSON Web Token (JWT).
            </p>
            <p>
              <b>Database: </b>&nbsp;
              ທ່ານຈະໄດ້ຮຽນຮູ້ກ່ຽວກັບການພັດທະນາລະບົບຖານຂໍ້ມູນໂດຍການນຳໃຊ້ Clound
              Firestore (NoSQL) ໃນການຂຽນຂໍ້ມູນລົງ ແລະ ດຶງມາໃຊ້ງານແບບ Real Time.
              ພ້ອມກັບການຮຽນຮູ້ SQL Server ຂຽນ Procedure ຕ່າງໆເພື່ອປະມວນຜົນ ແລະ
              ສົ່ງຂໍ້ມູນໃຫ້ກັບ Backend ນຳໄປໃຊ້ງານສ້າງ API.
            </p>
            <p>
              <b>Text editer:</b>&nbsp; ທ່ານຈະໄດ້ຮຽນຮູ້ກ່ຽວກັບການນຳໃຊ້ໂປຼແກຼມ
              Visual Studio Code ຈາກ Microsoft ລວມທັງ Extension
              ຕ່າງໆທີ່ເປັນປະໂຫຍດໃນການຂຽນໂປຼແກຼມ. ການປະຕິບັດຕົວຈິງ
              ເຊິ່ງເປັນສິ່ງສຳຄັນໃນຫຼັກສູດນີ້ ເພື່ອໃຫ້ສາມາດພັດທະນາໄດ້ດ້ວຍຕົວເອງ.
              ການປະຕິບັດຕົວຈິງຈະຄວບຄຸມການຈຳລອງລະບົບ
            </p>
            <p>
              <b>Netflix: </b>&nbsp; ໂດຍການດຶງເອົາ API ຈາກ The movies Database
              (TMDB) ມາໃຊ້ງານຈິງ ແລະ ສາມາດເບິ່ງ movies trailers ໄດ້.
            </p>
            <p>
              <b>Gmail: </b>&nbsp;ຈຳລອງໜ້າຕ່າງ ແລະ function
              ການໃຊ້ງານສົ່ງ-ຮັບອີເມລແບບ Real
            </p>
            <p>
              ສ້າງໜຶ່ງ Website ຂອງຕົວເອງ ພ້ອມກັບສາມາດ upload ຂຶ້ນ Firebase
              Google Cloud ແລະ ສາມາດນຳໃຊ້ໄດ້ຈິງ.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <b
              style={{
                fontFamily: "Noto Sans Lao",
                fontSize: "20px",
              }}
            >
              ເໝາະສໍາລັບຜູ້ທີ່:
            </b>
          </AccordionSummary>
          <AccordionDetails
            style={{
              display: "block",
              textAlign: "justify",
              fontFamily: "Phetsarath OT",
              fontSize: "17px",
            }}
          >
            <b>ຫຼັກສູດນີ້ ເໝາະສົມສຳລັບ</b>
            <p>
              1. ຜູ້ທີ່ຕ້ອງການຈະເປັນ Full Stack Web Application Programmer
              ໃນລະຍະເວລາອັນສັ້ນ ເພື່ອນຳໄປໃຊ້ງານໃນການສ້າງລະບົບ ຫຼື ສະໝັກວຽກ.
            </p>
            <p>2. ຜູ້ທີ່ຕ້ອງການຈະຮຽນຮູ້ ເພື່ອສ້າງ Website ຕົວເອງ.</p>
            <p>
              3. ຜູ້ທີ່ຕ້ອງການຮຽນຮູ້ NoSQL Database ແລະ SQL Database ເພື່ອຂຽນ
              Procedure ໃນລະບົບຖານຂໍ້ມູນ.
            </p>
            <p>
              4. ຜູ້ທີ່ຕ້ອງການຈະຮຽນຮູ້ການພັດທະນາ ຫຼື ສ້າງ Application
              Programming Interface (API) ໃນແບບທໍາມະດາ ແລະ
              ແບບທີ່ຕ້ອງໃຊ້ລະບຸຕົວຕົນຜ່ານ JSON Web Token Security Algorithm.
            </p>
            <p>
              5. ນັກສຶກສາທີ່ຈະໄປຮຽນຢູ່ມະຫາວິທະຍາໄລ ຫຼື
              ຮຽນຢູ່ມະຫາວິທະຍາໄລແລ້ວກໍ່ສາມາດຮຽນໄດ້.
            </p>
            <p>6. ຜູ້ທີ່ມີຄວາມສົນໃຈໃນວິຊາ Computer Programming.</p>
            <p>
              ນອກນັ້ນ
              ທ່ານຍັງຈະໄດ້ຮັບການແບ່ງປັນຄວາມຮູ້ຈາກປະສົບການຈິງນອກເໜືອຈາກຫຼັກສູດຂ້າງຕົ້ນທີ່ບໍ່ມີສອນໃນຫຼັກສູດຂອງມະຫາວິທະຍາໄລ.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <b>Course Study</b>
          </AccordionSummary>
          <AccordionDetails
            style={{
              display: "block",
              textAlign: "justify",
              fontFamily: "Phetsarath OT",
              fontSize: "17px",
            }}
          >
            <p>
              ຫຼັກສູດນີ້ ຈະສອນສະເພາະແຕ່ວັນເສົາ ແລະ ວັນອາທິດ, ວັນລະ 4
              ຊົ່ວໂມງເທົ່ານັ້ນ. ເລີ່ມສອນວັນທີ 20 ມີນາ 2021 ເປັນຕົ້ນໄປ.
            </p>
            <p>ເຮົາມີ 2 ຫຼັກສູດ ໃຫ້ທ່ານເລືອກຮຽນຕາມລາຍລະອຽດໃນ Outline Course</p>
            <p>
              <b>1. GEGINNER COURSE</b>&nbsp; (ສອນທັງໝົດຢູ່ 32 ຊົ່ວໂມງ):
            </p>
            <p>
              <b>Frontend: </b>&nbsp; React JS Fundamentals, HTML, CSS &
              Material-UI
            </p>
            <p>
              <b>Backend: </b>&nbsp; C# in ASP.Net (Visual Studio 2019)
            </p>
            <p>
              <b>Database: </b>&nbsp; Google Clound Firestore (NoSQL) &
              Microsoft SQL Server
            </p>
            <p>
              <b>Practical Project: </b>&nbsp; One practical project clone and
              one for build your own website
            </p>
            <p>
              <b>2. ADVANCED COURSE </b>&nbsp; (ສອນທັງໝົດຢູ່ 48 ຊົ່ວໂມງ):
            </p>
            <p>
              <b>Frontend: </b>&nbsp; React JS Fundamental + Advanced, HTML, CSS
              & Material UI (Advanced Topic)
            </p>
            <p>
              <b>Backend: </b>&nbsp; C# in ASP.Net (Visual Studio 2019)
              (Advanced Topic)
            </p>
            <p>
              <b>Database: </b>&nbsp; Google Clound Firestore (NoSQL) &
              Microsoft SQL Server
            </p>
            <p>
              <b>Practical Project: </b>&nbsp; Two practical project clone and
              one for build your own website
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <b
              style={{
                fontFamily: "Noto Sans Lao",
                fontSize: "20px",
              }}
            >
              ເງື່ອນໄຂທົ່ວໄປ.
            </b>
          </AccordionSummary>
          <AccordionDetails
            style={{
              display: "block",
              textAlign: "justify",
              fontFamily: "Phetsarath OT",
              fontSize: "17px",
            }}
          >
            <p>
              ຫຼັກສູດນີ້ ຈະສອນສະເພາະແຕ່ວັນເສົາ ແລະ ວັນອາທິດ, ວັນລະ 4
              ຊົ່ວໂມງເທົ່ານັ້ນ. ເລີ່ມສອນວັນທີ 20 ມີນາ 2021 ເປັນຕົ້ນໄປ.
            </p>
            <p>ເຮົາມີ 2 ຫຼັກສູດ ໃຫ້ທ່ານເລືອກຮຽນຕາມລາຍລະອຽດໃນ Outline Course</p>
            <p>
              ນັກຮຽນທຸກຄົນຕ້ອງມີ ຄອມພິວເຕີ ສ່ວນຕົວ (Laptop)
              ເພາະຈະໃຊ້ອຸປະກອນສ່ວນຕົວໃນການຮຽນການສອນ
            </p>
            <p>ທາງຜູ້ຝຶກສອນຈະມີບົດຮຽນໃຫ້ທັງໝົດ (ສະບັບພາສາອັງກິດ)</p>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
